import { usePathname, useRouter } from 'next/navigation';

import { useEffect } from 'react';

import Cookies from 'js-cookie';

const useUtmParams = () => {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const resultUTMParams: { [key: string]: string } = {};

    for (const [key, value] of searchParams.entries()) {
      if (key.startsWith('utm_')) {
        resultUTMParams[key] = value;
      }
    }

    if (Object.keys(resultUTMParams).length > 0) {
      Cookies.set('utm_params', JSON.stringify(resultUTMParams), { expires: 1 });
      Object.keys(resultUTMParams).map((key) => {
        searchParams.delete(key);
      });
      router.replace(`${pathname}?${searchParams.toString()}`);
    }
  }, [router, pathname]);
};

export default useUtmParams;
